import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
const StyledTimer = styled.span`
  color: var(--primary);
`;
const Timer = ({
  delayResend,
  action,
}: {
  delayResend: string;
  action: () => void;
}) => {
  const [delay, setDelay] = useState(+delayResend);
  const minutes = Math.floor(delay / 60);
  const seconds = Math.floor(delay % 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setDelay(delay - 1);
    }, 1000);

    if (delay === 0) {
      action();
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, [action, delay, delayResend]);

  return (
    <>
      <StyledTimer>
        {`${minutes.toLocaleString().length < 2 ? '0' : ''}${minutes}`}:
        {`${seconds.toLocaleString().length < 2 ? '0' : ''}${seconds}`}
      </StyledTimer>
    </>
  );
};

export default Timer;
